import { render } from "./OneToOneChatOptionsCard.vue?vue&type=template&id=0d833db1&scoped=true"
import script from "./OneToOneChatOptionsCard.vue?vue&type=script&lang=js"
export * from "./OneToOneChatOptionsCard.vue?vue&type=script&lang=js"

import "./OneToOneChatOptionsCard.vue?vue&type=style&index=0&id=0d833db1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d833db1"]])

export default __exports__